import {Action} from 'redux';

export interface ISessionAction extends Action {
  payload?: any;
}

export const webSocketCommand = (type: string, payload: any): ISessionAction => ({
  type,
  payload,
});
